<template>
    <div class="cafemap-main">
        <div class="overlay"></div>
        <div class="header-main">
            <a class="btn-back" @click="backHistory">
                <img
                    class="white-back"
                    src="@/assets/campaignlist/white_back.svg"
                    alt=""
                />
            </a>
            <div class="search-container">
                <input
                    id="cafemap-search-input"
                    class="search-input"
                    type="text"
                    v-model="inputSearch"
                    placeholder="ค้นหาสาขา"
                    @input="onSearch(inputSearch)"
                />
            </div>
        </div>
        <div class="google-map">
            <GmapMap
                :center="center"
                :zoom="15"
                :options="mapOptions"
                style="width: 100%; height: 55vh"
            >
                <GmapMarker
                    :icon="{ url: require('@/assets/mission/map_user.svg') }"
                    :position="center"
                    :draggable="false"
                />
                <GmapMarker
                    :key="index"
                    :icon="{ url: require('@/assets/mission/map_pin.svg') }"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :draggable="false"
                    @click="setCenter(m)"
                />
            </GmapMap>
        </div>
        <div id="cafemap-googlemap-map" class="body-main">
            <div class="cafe-header">
                <div class="nearby">สาขาใกล้ฉัน</div>
                <div class="branch">เลือกสาขา</div>
            </div>
            <div class="white-line head-line"></div>
            <ul class="cafe-body" id="cafemap-choosecafe-list">
                <li
                    v-for="(item, index) in filterArray"
                    :key="index"
                    class="cafe-content"
                    :class="{ odd: index % 2 }"
                    @click="gotoMenu(item)"
                >
                    <p>{{ item[0] }}</p>
                    <div class="distance-container">
                        <img
                            class="location-icon"
                            src="@/assets/campaignlist/thin_location.svg"
                        />
                        <span>{{ item[1] }} กม.</span>
                    </div>
                    <div class="white-line"></div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Mixin from "@/mixin/Mixin";
//core
import MenuApi from "@/module/Menu/service/missionbadge.js";
//vuex
import { mapActions } from "vuex";

export default {
    mixins: [Mixin],
    data() {
        return {
            inputSearch: "",
            nameArray: [],
            filterArray: [],
            mapOptions: {
                disableDefaultUI: true,
            },
            center: { lat: 13.7446841, lng: 100.5633786 }, //default
            markers: [],
            distance: 5000, //default
            getCallback: false,
        };
    },
    watch: {
        inputSearch(newVal, oldVal) {
            if (newVal != oldVal) {
                this.onSearch(newVal);
            }
        },
        getCallback(newVal, oldVal) {
            if (newVal != oldVal) {
                const getLocation = this.getLocation();
                Promise.all([getLocation])
                    .then(() => {
                        this.orderCafeName();
                        this.handleLoading(false);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
    },
    created() {
        this.handleLoading(true);
        this.getUserLocation();
    },
    methods: {
        ...mapActions(["setLocation"]),
        backHistory() {
            this.$router.push("/" + this.$route.params.targetpage);
        },
        getUserLocation() {
            return new Promise((resolve) => {
                window.navigator.geolocation.getCurrentPosition(
                    this.successHandler,
                    this.errorHandler,
                    { enableHighAccuracy: true, maximumAge: 10000 }
                );
                resolve(true);
            });
        },
        getLocation() {
            return new Promise((resolve, reject) => {
                this.form = `${this.center.lat},${this.center.lng}`;
                MenuApi.GetCafeLocation(this.distance, this.form).subscribe(
                    (response) => {
                        response.forEach((element) => {
                            this.markers.push({
                                position: {
                                    lat: element.location.latitude,
                                    lng: element.location.longitude,
                                },
                                name: element.name,
                                distance:
                                    Math.trunc(element.distance / 100) / 10,
                                workingDay: element.working_day,
                                id: element.id,
                            });
                        });
                        resolve(response);
                    },
                    (err) => {
                        console.log(err);
                        reject(err);
                    }
                );
            });
        },
        orderCafeName() {
            for (let i = 0; i < this.markers.length; i++) {
                this.nameArray.push([
                    this.markers[i].name,
                    parseFloat(this.markers[i].distance),
                    this.markers[i].position.lat,
                    this.markers[i].position.lng,
                    this.markers[i].workingDay,
                    this.markers[i].id,
                ]);
            }
            this.nameArray.sort((a, b) => {
                return a[1] > b[1] ? 1 : -1;
            });
            this.filterArray = this.nameArray;
        },
        successHandler: function (position) {
            this.center = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            };
            this.getCallback = true;
        },
        errorHandler: function (errorObj) {
            alert(
                errorObj.code +
                    ": " +
                    errorObj.message +
                    " use default location"
            );
            this.getCallback = true;
        },
        setCenter(marker) {
            this.center = marker.position;
            this.inputSearch = marker.name;
        },
        onSearch(inputSearch) {
            this.filterArray = this.nameArray.filter((str) => {
                return (
                    str[0].toLowerCase().indexOf(inputSearch.toLowerCase()) >= 0
                );
            });
        },
        gotoMenu(location) {
            this.setLocation({
                location: location[0],
                lat: location[2],
                lng: location[3],
                workingDay: location[4],
                id: location[5],
            });
            this.$router.push("/" + this.$route.params.targetpage);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/style/_mixin.scss";
p {
    margin: 0;
    padding: 0;
}
li,
ul {
    list-style: none;
    margin: 0;
    padding: 0;
}
::placeholder {
    color: #6f6963;
    opacity: 1;
}
.white-line {
    background-color: $color-text;
    height: 1px;
    width: calc(100vw - 40px);
    margin: 0;
    &.head-line {
        margin-left: 20px;
    }
}
.cafemap-main {
    .overlay {
        width: 100%;
        height: 13%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 6;
        background: linear-gradient(
            180deg,
            #ded6c9 0%,
            rgba(222, 214, 201, 0) 100%
        );
    }
    .header-main {
        .btn-back {
            display: flex;
            position: absolute;
            left: 20px;
            top: 65px;
            z-index: 9;

            img {
                height: 24px;
            }
        }
        .search-container {
            color: $color-text;
            position: absolute;
            left: 55px;
            top: 50px;
            z-index: 9;
            .search-input {
                border: #cac3b7 2px solid;
                height: 45px;
                width: 80vw;
                border-radius: 10px;
                background: url("../../../assets/campaignlist/search_icon.svg")
                    no-repeat 7px 7px;
                background-position: right 6px top 8px;
                background-color: #fff;
                padding: 0px 15px;
            }
        }
    }
    .google-map {
        position: relative;
        z-index: 5;
    }
    .body-main {
        z-index: 9;
        font-size: 16px;
        color: $color-text;
        position: fixed;
        bottom: 0;
        width: 100%;
        background-color: $color-light-grey-500;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        .cafe-header {
            background: $color-light-grey-500;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
            display: flex;
            justify-content: space-between;
            padding: 10px 20px;
            color: $color-text;
            .nearby {
                font-family: "PromptSemiBold";
            }
            .branch {
                margin-left: auto;
                margin-right: 0;
            }
        }
        .cafe-body {
            height: 40vh;
            overflow: scroll;
            font-weight: 200;
            .cafe-content {
                padding: 15px 20px 0px;
                background-color: #eee9e3;
                &.odd {
                    background-color: $color-light-grey-500;
                }
                .distance-container {
                    margin: 10px 0 15px;
                    img {
                        height: 28px;
                        margin-right: 5px;
                    }
                }
            }
        }
    }
}
</style>
